import { message } from 'antd'

import {
  TOSTMESSAGE,
  DEFAULT_ERROR_MSG,
  DEFAULT_WARRNING_MSG,
} from '@Constants'

export const TostError = (msg) => message.error(msg || TOSTMESSAGE)
export const TostWarning = (msg) => message.warning(msg || TOSTMESSAGE)
export const TostSuccess = (msg) => message.success(msg || TOSTMESSAGE)

export const renderAPIErrorMsg = ({ res = {}, customMsg } = {}) =>
  TostWarning(
    customMsg ||
      res?.error?.responseMsg ||
      res?.response?.error_description ||
      DEFAULT_ERROR_MSG
  )

export const renderAPIWarningMsg = (res = {}, customMsg = {}) =>
  TostWarning(customMsg != null ? customMsg : DEFAULT_WARRNING_MSG)
